export default __webpack_public_path__ + "static/media/logoFooter.53ac3977.png";